import React, { useState } from "react"
import styled from "styled-components"
import Option from "./Question"
import { getHeaderTheme } from "../config/headerTheme"

const EvaluationHost = ({ onSelection, onNoVoting, onThanksPage, customQuestions }) => {
    const [options, setOptions] = useState({
        question1: 0,
        question2: 0,
        question3: 0,
        question4: 0,
        question5: 0,
        clientEmail: null,
        authForGoogle: false,
        authForFacebook: false,
        clientName: null,
    })
    const [isSubmitting, setIsSubmitting] = useState(false)

    const hasAllAnswers = () => {
        const baseQuestions = [
            options.question1,
            options.question2,
            options.question3,
            options.question4,
            options.question5,
        ];
        const allBaseAnswered = baseQuestions.every((v) => v > 0);
        if (!allBaseAnswered) return false;

        if (customQuestions && customQuestions.length > 0) {
            return customQuestions.every((q) => options[q.id] > 0);
        }
        return true;
    }

    const onSelect = (id, value) => {
        const o = { ...options, [id]: value }
        setOptions(o)
    }

    const handleSubmit = async () => {
        if (isSubmitting) return;
        if (!hasAllAnswers()) {
            alert("Por favor responde todas las preguntas antes de enviar.");
            return;
        }

        try {
            setIsSubmitting(true);
            await onSelection(options);
            onThanksPage(true);
            onNoVoting();
        } catch (error) {
            console.error("Error al enviar evaluación:", error);
            alert("Error al procesar tu evaluación. Por favor, intenta nuevamente.");
        } finally {
            setIsSubmitting(false);
        }
    }

    return (
        <>
            <Evaluations>
                <Heading>Evalúa esta tienda.</Heading>

                <Option id="question1" label="¿Cómo evaluarías la limpieza y el orden de la tienda?" onSelect={onSelect} />
                <Option id="question2" label="¿Cómo evaluarías la amabilidad en la atención?" onSelect={onSelect} />
                <Option id="question3" label="¿Cómo evaluarías la rapidez para atenderte y entregar tu compra?" onSelect={onSelect} />
                <Option id="question4" label="¿Cómo evaluarías la ayuda para encontrar o elegir productos?" onSelect={onSelect} />
                <Option id="question5" label="¿Cómo evaluarías esta oferta de precios?" onSelect={onSelect} />
                
                {customQuestions && customQuestions.length > 0 && customQuestions?.map((e, index) => {
                    return (<Option key={e.id || `custom-${index}`} id={e.id} label={e.label} onSelect={onSelect} />)
                })}

                <ButtonsSocial>
                    <SubmitButton type="button" onClick={handleSubmit} disabled={isSubmitting || !hasAllAnswers()}>
                        {isSubmitting ? "Enviando..." : "Enviar evaluación"}
                    </SubmitButton>
                </ButtonsSocial>
            </Evaluations>
        </>
    )
}

export default EvaluationHost

/* ========= styled-components ========= */

const Evaluations = styled.div`
  padding: 20px 15px;
`

const Heading = styled.h6`
  font-size: 18px;
  font-weight: 600;
  margin: 0 0 12px 0;
  color: #111827;
`

const ButtonsSocial = styled.div`
  margin-top: 8px;
  display: flex;
  flex-direction: column;
  gap: 10px;
`

const theme = getHeaderTheme();

const SubmitButton = styled.button`
  height: 52px;
  width: 100%;
  background: ${theme.primary};
  border: none;
  border-radius: 100px;
  color: ${theme.text};
  font-weight: 700;
  font-size: 15px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  transition: filter 0.2s ease;

  &:hover:not(:disabled) {
    filter: brightness(0.92);
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`
